import { BILLING_DESTINATIONS } from "./billing.destinations";
import { CALLS_DESTINATIONS } from "./calls.destinations";
import { COLLECTIONS_DESTINATIONS } from "./collections.destinations";
import { DASHBOARD_DESTINATIONS } from "./dashboard.destinations";
import type { QuickLauncherDestination } from "./destination.types";
import { INBOX_DESTINATIONS } from "./inbox.destinations";
import { INVENTORY_DESTINATIONS } from "./inventory.destinations";
import { LEADS_DESTINATIONS } from "./leads.destinations";
import { MARKETING_DESTINATIONS } from "./marketing.destinations";
import { QUICKBOOKS_DESTINATIONS } from "./quickbooks.destinations";
import { REPORT_DESTINATIONS } from "./reports.destinations";
import { SALES_COACH_DESTINATIONS } from "./sales-coach.destinations";
import { SCHEDULING_DESTINATIONS } from "./scheduling.destinations";
import { SETTINGS_DESTINATIONS } from "./settings.destinations";

/** Every destination, in the side menu's section order. */
export const QUICK_LAUNCHER_DESTINATIONS: QuickLauncherDestination[] = [
  ...DASHBOARD_DESTINATIONS,
  ...INBOX_DESTINATIONS,
  ...SCHEDULING_DESTINATIONS,
  ...BILLING_DESTINATIONS,
  ...COLLECTIONS_DESTINATIONS,
  ...REPORT_DESTINATIONS,
  ...MARKETING_DESTINATIONS,
  ...SALES_COACH_DESTINATIONS,
  ...CALLS_DESTINATIONS,
  ...LEADS_DESTINATIONS,
  ...INVENTORY_DESTINATIONS,
  ...SETTINGS_DESTINATIONS,
  ...QUICKBOOKS_DESTINATIONS
];
